import RichContent from '@/components/RichContent';
import { useAppContext } from '@/context/app';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { useStyle } from '../../classify';
import defaultClasses from './category.module.css';

export const CategoryDescription = ({
  categoryDescription,
  mobileCategoryDescriptionTitle,
}: {
  categoryDescription: string;
  mobileCategoryDescriptionTitle: string;
}) => {
  const { isMobile } = useIsMobile();
  const DRAWER_NAME = 'filter';
  const [{ drawer }, { toggleDrawer }] = useAppContext();

  const classes = useStyle(defaultClasses);
  const categoryDescriptionElement = categoryDescription ? (
    <RichContent
      classes={{
        root: classes.categoryDescriptionContent,
      }}
      html={categoryDescription}
    />
  ) : null;
  // const categoryDescriptionElement = categoryDescription ? (
  //   isMobile ? (
  //     <>
  //       <div
  //         className={'mb-5 text-left font-roboto-medium text-[18px] text-primary'}
  //         onClick={() => toggleDrawer(DRAWER_NAME)}
  //       >
  //         {mobileCategoryDescriptionTitle}
  //       </div>
  //     </>
  //   ) : (
  //     <RichContent
  //       classes={{
  //         root: classes.categoryDescriptionContent,
  //       }}
  //       html={categoryDescription}
  //     />
  //   )
  // ) : null;

  return (
    <div className={'category_categoryDescription__H5Li5 mt-[20px] lg_mt-[40px]'}>{categoryDescriptionElement}</div>
  );
};
